import templateUrl from 'emun.customer/customer-campaign-activity.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import ServiceBus from 'servicestack/service-bus'

class CustomerCampaignActivityController {
    constructor($rootScope) {
        const $ctrl = this;
        basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		var request = {
			campaignId: $ctrl.id,
			customerId: $ctrl.customerId
		};
		$ctrl.bus.send('GetCampaignActivityByCustomer.json', request).then(res => {
			$ctrl.activity = res.data;
		});
    }
}

let CustomerCampaignActivity = {
    bindings: {
        id: '@',
        customerId: '@',
        retailerId: '@',
		customer: '<',
		contactId: '@'
    },
	controller: CustomerCampaignActivityController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default CustomerCampaignActivity